export const getStepIndex = (stepId, steps) => {
    if (stepId) {
        const stepIndex = steps?.findIndex((step) => step.id === stepId);
        if (stepIndex !== undefined && stepIndex !== -1) {
            return stepIndex;
        }
    }
    return 0;
};
//# sourceMappingURL=get-step-index.js.map